import "./candidates.scss";
import {
  Box,
  Button,
  Chip,
  Typography,
  Avatar,
  Stack,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Grid,
  Select,
  MenuItem as SelectMenuItem,
  FormControl,
  InputLabel,
  Paper,
  Drawer,
  Divider,
  Badge,
  CircularProgress,
  Autocomplete,
  Backdrop,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import DownloadIcon from "@mui/icons-material/Download";
import InsightsIcon from "@mui/icons-material/Insights";
import ClearIcon from "@mui/icons-material/Clear";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useEffect } from "react";
import {
  getRequestWithToken,
  deleteRequest,
} from "../../utils/ApiRequests";
import SureYouWantToDeletModal from "../../components/SureYouWantToDeleteModal/SureYouWantToDeletModal";
import ReusableLoader from "../../components/ReusableLoader/ReusableLoader";
import { GlobalContext } from "../../components/GlobalStateProvide/GlobalStateProvider";
import { checkPermission } from "../../utils/userPermissions";
import Unauthorized from "../../components/unauthorized/Unauthorized";
import { useMaterialReactTable } from "material-react-table";
import DataTable from "../../ui/data/DataTable";
import { axiosInstance } from "../../axiosconfing";

const regFormStatusOptions = [
  { value: "", label: "All steps" },
  { value: "0", label: "0 - Not Started" },
  // { value: "1", label: "1 - Signup Started" },
  { value: "2", label: "2 - Basic Details Completed" },
  { value: "3", label: "3 - Role And Languages Completed" },
  { value: "4", label: "4 - Job Preferences Completed" },
  { value: "5", label: "5 - Completed" },
];

const getRegFormStatusLabel = (value) => regFormStatusOptions.find((item) => item.value === String(value))?.label || value;

const Candidates = () => {
  const [candidateData, setCandidateData] = useState([]);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [candidateId, setCandidateId] = useState("");
  const [showLoader, setShowLoader] = useState(true);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [rowCount, setRowCount] = useState(0);
  const [loadingDataInGrid, setLoadingDataInGrid] = useState(null);
  const [exportLoading, setExportLoading] = useState(false);
  const navigate = useNavigate();

  const { handleSnackBar } = useContext(GlobalContext);

  const [canCreate, setCanCreate] = useState(false);
  const [canDelete, setCanDelete] = useState(false);
  const [canUpdate, setCanUpdate] = useState(false);
  const [canRead, setCanRead] = useState(false);

  const [isAccess, setisAccess] = useState([]);
  const [isIncludesValue, setisIncludesValue] = useState(null);

  const [showDeletedRows, setShowDeletedRows] = useState(true);
  const [showCompleteProfiles, setShowCompleteProfiles] = useState(true);
  const [searchBarValue, setSearchBarValue] = useState("");

  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState('');
  const [sorting, setSorting] = useState([]);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isError, setIsError] = useState(false);

  // Custom filter state
  const [customFilters, setCustomFilters] = useState({
    name: '',
    email: '',
    mobile: '',
    pincode: '',
    qualification: '',
    source: '',
    registrationFrom: '',
    registrationTo: '',
    onboardingStatus: '',
    regFormStatus: '',
    familyId: '',
    groupId: '',
    roleId: '',
    state: '',
    district: '',
    city: '',
    hasApplied: '',
  });

  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
  const [roleFilterOptions, setRoleFilterOptions] = useState({ families: [], groups: [], roles: [] });
  const [roleFilterLoading, setRoleFilterLoading] = useState({ families: false, groups: false, roles: false });
  const [roleFilterError, setRoleFilterError] = useState("");

  const [columnPinning, setColumnPinning] = useState({
    left: [],
    right: []
  });
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const handleToggleChange = () => {
    setShowDeletedRows(!showDeletedRows);
  };

  const handleCompleteProfilesChange = () => {
    setShowCompleteProfiles(!showCompleteProfiles);
  };

  const filteredRows = candidateData.filter((candidate) => {
    const isDeletedMatch =
      showDeletedRows ||
      (candidate.deleted && candidate.deleted.is_deleted === false);
    const isProfileCompleteMatch =
      showCompleteProfiles ||
      (candidate.is_profile_complete &&
        candidate.is_profile_complete.toLowerCase() === "yes");

    return isDeletedMatch && isProfileCompleteMatch;
  });

  const createNewCandidate = () => {
    navigate("/candidate/create");
  };

  const qualificationArray = [
    // "Any",
    "10th Pass",
    "12th Pass",
    "Diploma After 10th",
    "Diploma After 12th",
    "Graduate",
    "Post Graduate",
    "ITI"
  ]

  const qualificationObj = {
    // 1: "Any",
    2: "10th Pass",
    3: "12th Pass",
    4: "Diploma After 10th",
    5: "Diploma After 12th",
    6: "Graduate",
    7: "Post Graduate",
    8: "ITI"
  };

  const getQualificationString = (number) => {


    return qualificationObj[number] || "";
  };

  const buildCandidateFilterParams = () => Object.fromEntries(
    columnFilters.map(filter => {
      if (filter.id === 'qualification') {
        const qualificationKey = Object.keys(qualificationObj).find(
          key => qualificationObj[key] === filter.value
        );
        return [filter.id, qualificationKey || filter.value];
      }
      return [filter.id, filter.value];
    })
  );



  const getRoleLabel = (item, type) => {
    if (type === "family") return item.family_ui_label || item.family_name || item.family_id || "-";
    if (type === "group") return item.role_group_ui_label || item.role_group_name || item.role_group_id || "-";
    return item?.display?.display_title || item?.display?.candidate_display_title || item?.role?.role_ui_label || item?.role?.role_name || item?.role?.role_id || "-";
  };

  const loadRoleFilterFamilies = async () => {
    setRoleFilterLoading((prev) => ({ ...prev, families: true }));
    setRoleFilterError("");
    try {
      const res = await getRequestWithToken("../v3/admin/candidate-role-mappings/families/list");
      setRoleFilterOptions((prev) => ({ ...prev, families: res.data?.data || [] }));
    } catch (err) {
      setRoleFilterError("Unable to load role families");
    } finally {
      setRoleFilterLoading((prev) => ({ ...prev, families: false }));
    }
  };

  const loadRoleFilterGroups = async (familyValue) => {
    const family = roleFilterOptions.families.find((item) => item.family_id === familyValue);
    setRoleFilterOptions((prev) => ({ ...prev, groups: [], roles: [] }));
    if (!family?._id) return;
    setRoleFilterLoading((prev) => ({ ...prev, groups: true }));
    setRoleFilterError("");
    try {
      const res = await getRequestWithToken(`../v3/admin/candidate-role-mappings/families/${family._id}/groups`);
      setRoleFilterOptions((prev) => ({ ...prev, groups: res.data?.data || [] }));
    } catch (err) {
      setRoleFilterError("Unable to load role groups");
    } finally {
      setRoleFilterLoading((prev) => ({ ...prev, groups: false }));
    }
  };

  const loadRoleFilterRoles = async (groupValue) => {
    const group = roleFilterOptions.groups.find((item) => item.role_group_id === groupValue);
    setRoleFilterOptions((prev) => ({ ...prev, roles: [] }));
    if (!group?._id) return;
    setRoleFilterLoading((prev) => ({ ...prev, roles: true }));
    setRoleFilterError("");
    try {
      const res = await getRequestWithToken(`../v3/admin/candidate-role-mappings/groups/${group._id}/roles`);
      setRoleFilterOptions((prev) => ({ ...prev, roles: res.data?.data || [] }));
    } catch (err) {
      setRoleFilterError("Unable to load roles");
    } finally {
      setRoleFilterLoading((prev) => ({ ...prev, roles: false }));
    }
  };

  useEffect(() => {
    if (filterDrawerOpen && roleFilterOptions.families.length === 0) {
      loadRoleFilterFamilies();
    }
  }, [filterDrawerOpen]);

  useEffect(() => {
    if (customFilters.familyId) loadRoleFilterGroups(customFilters.familyId);
  }, [customFilters.familyId, roleFilterOptions.families.length]);

  useEffect(() => {
    if (customFilters.groupId) loadRoleFilterRoles(customFilters.groupId);
  }, [customFilters.groupId, roleFilterOptions.groups.length]);

  const ActionMenu = ({ row }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const isMenuOpen = Boolean(anchorEl);
    const isDeleted = row.original.deleted?.is_deleted;

    const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
    const handleMenuClose = () => setAnchorEl(null);

    return (
      <>
        <IconButton onClick={handleMenuOpen} size="small" disabled={isDeleted}>
          <MoreVertIcon fontSize="small" />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={isMenuOpen}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
        >
          {canRead && (
            <MenuItem
              onClick={() => {
                handleMenuClose();
                navigate(`/candidate/detail/${row.original.mobile}`);
              }}
            >
              <VisibilityIcon fontSize="small" sx={{ mr: 1 }} />
              View
            </MenuItem>
          )}
          {canUpdate && (
            <MenuItem
              onClick={() => {
                handleMenuClose();
                navigate("/candidate/create", { state: row.original });
              }}
            >
              <EditIcon fontSize="small" sx={{ mr: 1 }} />
              Edit
            </MenuItem>
          )}
          {canDelete && (
            <MenuItem
              onClick={() => {
                handleMenuClose();
                setCandidateId(row.original._id);
                setOpenDeleteModal(true);
              }}
            >
              <DeleteIcon fontSize="small" sx={{ mr: 1 }} color="error" />
              Delete
            </MenuItem>
          )}
        </Menu>
      </>
    );
  };

  const columns = [
    {
      accessorKey: "id",
      header: "S.No.",
      size: 100,
      enableColumnActions: false,
      enableColumnFilter: false,
      Cell: ({ row, table }) => {
        const pageIndex = table.getState().pagination.pageIndex;
        const pageSize = table.getState().pagination.pageSize;
        return <span>{row.index + 1 + (pageIndex * pageSize)}</span>;
      },
    },
    {
      accessorKey: "profile",
      header: "Profile",
      size: 260,
      enableColumnFilter: false,
      Cell: ({ row }) => {
        const { first_name = "", middle_name = "", last_name = "" } = row.original;
        const fullName = `${first_name} ${middle_name} ${last_name}`.trim() || "---";
        const initials = fullName
          .split(" ")
          .filter(Boolean)
          .slice(0, 2)
          .map((part) => part[0].toUpperCase())
          .join("") || "?";
        return (
          <Stack direction="row" spacing={1.5} alignItems="center">
            <Avatar sx={{ width: 32, height: 32, bgcolor: "#FF8C00" }}>
              {initials}
            </Avatar>
            <Stack spacing={0.2}>
              <Typography variant="subtitle2" sx={{ color: "#FF8C00" }}>
                {fullName}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {row.original.email || "---"}
              </Typography>
            </Stack>
          </Stack>
        );
      },
    },
    {
      accessorKey: "buid",
      header: "Candidate ID",
      size: 160,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <Typography variant="caption" color="text.secondary">
          {row.original.candidate_id || row.original.buid || "---"}
        </Typography>
      ),
    },
    {
      accessorKey: "contact",
      header: "Contact",
      size: 160,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <Stack spacing={0.2}>
          <Typography variant="subtitle2">
            {row.original.mobile || "---"}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {row.original.alternate_phone || row.original.alternative_phone || "---"}
          </Typography>
        </Stack>
      ),
    },
    {
      accessorKey: "location",
      header: "Location",
      size: 170,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <Typography variant="subtitle2">
          {[row.original.district, row.original.state].filter(Boolean).join(", ") || "---"}
        </Typography>
      ),
    },

    {
      accessorKey: "onboarding status",
      header: "Onboarding Status",
      size: 180,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <Chip
          size="small"
          label={getRegFormStatusLabel(row.original.reg_form_status) || "Not Started"}
          color={row.original.reg_form_status === "5" ? "success" : row.original.reg_form_status > "0" ? "warning" : "error"}
          variant="outlined"
        />
      ),
    },
    {
      accessorKey: "selected_role",
      header: "Family / Group / Role",
      size: 300,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <Stack spacing={0.2}>
          <Typography variant="caption">{row.original.family?.family_ui_label || "---"}</Typography>
          <Typography variant="caption" color="text.secondary">{row.original.role_group?.role_group_ui_label || "---"}</Typography>
          <Typography variant="subtitle2">{row.original.display?.display_title || row.original.role?.role_ui_label || "---"}</Typography>
        </Stack>
      ),
    },
    {
      accessorKey: "pincode",
      header: "Pincode",
      size: 120,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <Typography variant="caption" color="text.secondary">
          {row.original.pincode || "---"}
        </Typography>
      ),
    },
    {
      accessorKey: "qualification",
      header: "Qualification",
      size: 230,
      Cell: ({ row }) => {
        const qualifications = row?.original?.qualification;
        if (!qualifications || qualifications.length === 0) {
          return "--";
        }

        if (Array.isArray(qualifications)) {
          return qualifications.map((qual) => getQualificationString(qual)).join(", ");
        }

        return getQualificationString(qualifications);
      },
      filterVariant: "select",
      filterSelectOptions: qualificationArray,
    },
    {
      accessorKey: "kyc_status",
      header: "KYC",
      size: 120,
      id: "kyc",
      Cell: ({ row }) => (
        <Chip
          variant="outlined"
          label={row.original.kyc_status ? "Verified" : "Pending"}
          color={row.original.kyc_status ? "success" : "default"}
          size="small"
        />
      ),
    },
    {
      accessorKey: "createdAt",
      header: "Registration Date",
      size: 180,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <Stack spacing={0.4}>
          <Chip
            variant="outlined"
            label={row.original.deleted?.is_deleted ? "Deleted" : "Active"}
            color={row.original.deleted?.is_deleted ? "error" : "success"}
            size="small"
          />
          <Typography variant="caption" color="text.secondary">
            {new Date(row.original.createdAt).toLocaleString("en-US", {
              timeZone: "Asia/Kolkata",
            })}
          </Typography>
        </Stack>
      ),
    },


    // {
    //   accessorKey: "app_download_status",
    //   header: "App Download",
    //   size: 150,
    //   enableColumnFilter: false,
    //   Cell: ({ row }) => (
    //     <Typography variant="caption" color="text.secondary">
    //       {row.original.app_download_status ? "Yes" : "No"}
    //     </Typography>
    //   ),
    // },

    // {
    //   accessorKey: "app_last_activity_time",
    //   header: "Last Activity",
    //   size: 180,
    //   enableColumnFilter: false,
    //   Cell: ({ row }) => (
    //     <Typography variant="caption" color="text.secondary">
    //       {row.original.app_last_activity_time
    //         ? new Date(row.original.app_last_activity_time).toLocaleString(
    //           "en-US",
    //           {
    //             timeZone: "Asia/Kolkata",
    //           }
    //         )
    //         : "--"}
    //     </Typography>
    //   ),
    // },
    {
      accessorKey: "jobApplyCount",
      header: "Total Applications",
      size: 140,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <Typography variant="subtitle2">
          {row.original.jobApplyCount || 0}
        </Typography>
      ),
    },

    {
      accessorKey: "latestApplicationDate",
      header: "Latest Application",
      size: 180,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <Typography variant="caption" color="text.secondary">
          {row.original.latestApplicationDate ? new Date(row.original.latestApplicationDate).toLocaleString("en-US", { timeZone: "Asia/Kolkata" }) : "--"}
        </Typography>
      ),
    },
    {
      accessorKey: "updatedAt",
      header: "Profile Updated",
      size: 180,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <Typography variant="caption" color="text.secondary">
          {row.original.updatedAt ? new Date(row.original.updatedAt).toLocaleString("en-US", { timeZone: "Asia/Kolkata" }) : "--"}
        </Typography>
      ),
    },
    {
      accessorKey: "action",
      header: "Action",
      size: 80,
      enableColumnFilter: false,
      enableColumnActions: false,
      Cell: ({ row }) => <ActionMenu row={row} />,
    },
  ];

  const deleteCandidate = async () => {
    try {
      let response = await deleteRequest(
        `admin?usertype=job_seeker&&userid=${candidateId}`
      );

      handleSnackBar(true, response.data.msg, "success");
      setOpenDeleteModal(false);
      setShowLoader(true);
      getAllCandidates();
    } catch (err) {
      handleSnackBar(true, err?.response?.data?.msg, "error");
      setOpenDeleteModal(false);
    }
  };

  const getAllCandidates = async () => {
    setLoadingDataInGrid(true);
    try {
      let response = await getRequestWithToken(
        `admin?usertype=job_seeker&page=${parseInt(
          pagination.pageIndex + 1
        )}&limit=${pagination.pageSize}&deleted=false&search=${searchBarValue}`
      );
      // console.log("response", response.data);
      setCandidateData(response?.data?.data);
      setRowCount(response?.data?.totalcount);
      setLoadingDataInGrid(false);
      setShowLoader(false);
    } catch (error) {
      handleSnackBar(
        true,
        error?.response?.data?.message || error?.message,
        "error"
      );
      setShowLoader(false);
      setLoadingDataInGrid(false);
    }
  };

  const handleCustomFilterChange = (field, value) => {
    setCustomFilters(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const applyCustomFilters = () => {
    const filters = [];
    Object.entries(customFilters).forEach(([key, value]) => {
      if (value) {
        filters.push({ id: key, value });
      }
    });
    setColumnFilters(filters);
    setPagination(prev => ({ ...prev, pageIndex: 0 }));
  };


  const exportCandidates = async () => {
    setExportLoading(true);
    try {
      const filterParams = buildCandidateFilterParams();
      const query = new URLSearchParams({ ...filterParams, search: searchBarValue || "" }).toString();
      const response = await axiosInstance.get(`admin/candidates/export?${query}`, { responseType: "blob" });
      const blob = new Blob([response.data], { type: response.headers["content-type"] });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `candidate-export-${Date.now()}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      handleSnackBar(true, err?.response?.data?.msg || err.message, "error");
    } finally {
      setExportLoading(false);
    }
  };

  const clearCustomFilters = () => {
    setCustomFilters({
      name: '',
      email: '',
      mobile: '',
      pincode: '',
      qualification: '',
      source: '',
      registrationFrom: '',
      registrationTo: '',
      onboardingStatus: '',
      regFormStatus: '',
      familyId: '',
      groupId: '',
      roleId: '',
      state: '',
      district: '',
      city: '',
      hasApplied: '',
    });
    setColumnFilters([]);
    setPagination(prev => ({ ...prev, pageIndex: 0 }));
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!candidateData.length) {
        setLoadingDataInGrid(true);
      } else {
        setIsRefetching(true);
      }

      try {
        const filterParams = buildCandidateFilterParams();

        const filterQueryString = new URLSearchParams(filterParams).toString();

        const response = await getRequestWithToken(
          `admin?usertype=job_seeker&page=${pagination.pageIndex + 1}&limit=${pagination.pageSize}&deleted=false&${filterQueryString}`
        );

        setCandidateData(response?.data?.data);
        setRowCount(response?.data?.totalcount);
        setIsError(false);
        setLoadingDataInGrid(false);
        setShowLoader(false);
      } catch (error) {
        setIsError(true);
        handleSnackBar(
          true,
          error?.response?.data?.message || error?.message,
          "error"
        );
        setLoadingDataInGrid(false);
      }
      setLoadingDataInGrid(false);
      setIsRefetching(false);
      setShowLoader(false);
    };

    fetchData();
  }, [columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,]);


  const checkPermissionFunc = () => {
    const resourceToUpdate = "Candidate";
    const permissions = checkPermission(resourceToUpdate);
    setCanCreate(permissions.canCreate);
    setCanDelete(permissions.canDelete);
    setCanUpdate(permissions.canUpdate);
    setCanRead(permissions.canRead);
  };

  const againCheckPermissions = () => {
    const checkAccesInArray = localStorage.getItem("resourceNames");
    const parsedResources = checkAccesInArray ? JSON.parse(checkAccesInArray) : [];
    setisAccess(parsedResources);
    setisIncludesValue(parsedResources.includes("Candidate"));
  };

  const isIncludes = () => {
    setisIncludesValue(isAccess.includes("Candidate"));
  };

  useEffect(() => {
    checkPermissionFunc();
    againCheckPermissions();
  }, [isIncludesValue, searchBarValue]);

  const table = useMaterialReactTable({
    columns,
    data: candidateData,
    initialState: {
      showColumnFilters: false,
      density: "compact",
      columnPinning: { right: ["action"] },
    },
    manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    enableStickyHeader: true,
    enableStickyFooter: true,
    enableColumnPinning: true,
    enableColumnResizing: true,
    enableGlobalFilter: false,
    enableSorting: false,
    enableHiding: true,
    muiSkeletonProps: {
      animation: 'wave',
    },
    muiLinearProgressProps: {
      color: 'secondary',
    },
    muiCircularProgressProps: {
      color: 'secondary',
    },
    muiToolbarAlertBannerProps: isError
      ? {
        color: 'error',
        children: 'No Data',
      }
      : undefined,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    rowCount,
    state: {
      columnFilters,
      globalFilter,
      isLoading: loadingDataInGrid,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      sorting,
    },
    renderBottomToolbarCustomActions: ({ table }) => {
      const { pageIndex, pageSize } = table.getState().pagination;
      const totalPages = Math.ceil(rowCount / pageSize);
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography variant="body2" style={{ marginLeft: "10px" }}>
            Page {pageIndex + 1} of {totalPages}
          </Typography>
        </Box>
      );
    },
    renderTopToolbarCustomActions: ({ table }) => {
      const pinnedColumns = table.getState().columnPinning || {};
      const leftPinned = pinnedColumns.left || [];
      const rightPinned = pinnedColumns.right || [];
      return (
        <Box>
          <Chip
            label={`Left Pinned: ${leftPinned.length}`}
            color="primary"
            sx={{ mr: 1 }}
          />
          <Chip
            label={`Right Pinned: ${rightPinned.length}`}
            color="secondary"
          />
        </Box>
      );
    },
  });

  return isIncludesValue ? (
    <Box className="candidates-section">

      <Box
        className="candidates-top-section"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "12px",
          padding: "12px 16px",
          borderRadius: "16px",
          background: "rgba(255, 255, 255, 0.85)",
          boxShadow: "0 10px 24px rgba(50, 30, 60, 0.08)",
        }}
      >
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            Candidates
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Track talent pipeline and status updates.
          </Typography>
        </Box>
        <Stack direction="row" spacing={2}>
          <Button variant="outlined" startIcon={<InsightsIcon />} onClick={() => navigate("/candidate/analytics")} sx={{ borderRadius: 999 }}>
            Analytics
          </Button>
          <Button variant="outlined" startIcon={<DownloadIcon />} onClick={exportCandidates} disabled={exportLoading} sx={{ borderRadius: 999 }}>
            {exportLoading ? "Exporting..." : "Export"}
          </Button>
          <Badge
            badgeContent={columnFilters.length}
            color="error"
            invisible={columnFilters.length === 0}
          >
            <Button
              variant="outlined"
              startIcon={<FilterListIcon />}
              onClick={() => setFilterDrawerOpen(true)}
              sx={{
                borderRadius: 999,
                borderColor: "#f26d3d",
                color: "#f26d3d",
                "&:hover": { borderColor: "#e35e2f", bgcolor: "rgba(242, 109, 61, 0.04)" },
              }}
            >
              Filters
            </Button>
          </Badge>
          {canCreate && (
            <Button
              variant="contained"
              sx={{
                borderRadius: 999,
                bgcolor: "#f26d3d",
                "&:hover": { bgcolor: "#e35e2f" },
              }}
              onClick={createNewCandidate}
            >
              + Create Candidate
            </Button>
          )}
        </Stack>
      </Box>

      {/* Active Filters Display */}
      {columnFilters.length > 0 && (
        <Paper
          elevation={0}
          sx={{
            backgroundColor: 'transparent',
          }}
        >
          <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" gap={1}>
            <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.secondary' }}>
              Active Filters:
            </Typography>
            {columnFilters.map((filter) => {
              let label = '';
              switch (filter.id) {
                case 'name':
                  label = `Name: ${filter.value}`;
                  break;
                case 'email':
                  label = `Email: ${filter.value}`;
                  break;
                case 'mobile':
                  label = `Mobile: ${filter.value}`;
                  break;
                case 'pincode':
                  label = `Pincode: ${filter.value}`;
                  break;
                case 'qualification':
                  label = `Qualification: ${filter.value}`;
                  break;
                case 'source':
                  label = `Source: ${filter.value}`;
                  break;
                case 'registrationFrom':
                  label = `Registered From: ${filter.value}`;
                  break;
                case 'registrationTo':
                  label = `Registered To: ${filter.value}`;
                  break;
                case 'onboardingStatus':
                  label = `Onboarding: ${filter.value === 'complete' ? 'Complete' : 'Incomplete'}`;
                  break;
                case 'regFormStatus':
                  label = `Raw Status: ${getRegFormStatusLabel(filter.value)}`;
                  break;
                case 'familyId':
                  label = `Family: ${roleFilterOptions.families.find((item) => item.family_id === filter.value)?.family_ui_label || filter.value}`;
                  break;
                case 'groupId':
                  label = `Group: ${roleFilterOptions.groups.find((item) => item.role_group_id === filter.value)?.role_group_ui_label || filter.value}`;
                  break;
                case 'roleId':
                  label = `Role: ${roleFilterOptions.roles.find((item) => item.role?.role_id === filter.value)?.display?.display_title || filter.value}`;
                  break;
                case 'hasApplied':
                  label = `Has Applied: ${filter.value === 'true' ? 'Yes' : 'No'}`;
                  break;
                default:
                  label = `${filter.id}: ${filter.value}`;
              }
              return (
                <Chip
                  key={filter.id}
                  label={label}
                  size="small"
                  onDelete={() => {
                    const newFilters = columnFilters.filter(f => f.id !== filter.id);
                    setColumnFilters(newFilters);
                    setCustomFilters(prev => ({
                      ...prev,
                      [filter.id]: ''
                    }));
                  }}
                  sx={{
                    bgcolor: 'rgba(242, 109, 61, 0.1)',
                    color: '#f26d3d',
                    borderColor: '#f26d3d',
                    '& .MuiChip-deleteIcon': {
                      color: '#f26d3d',
                      '&:hover': {
                        color: '#e35e2f',
                      },
                    },
                  }}
                />
              );
            })}
            <Button
              size="small"
              onClick={clearCustomFilters}
              sx={{
                textTransform: 'none',
                color: 'text.secondary',
                fontSize: '0.75rem',
                minWidth: 'auto',
                '&:hover': {
                  bgcolor: 'rgba(0, 0, 0, 0.04)',
                },
              }}
            >
              Clear all
            </Button>
          </Stack>
        </Paper>
      )}

      {/* Filter Drawer */}
      <Drawer
        anchor="right"
        open={filterDrawerOpen}
        onClose={() => setFilterDrawerOpen(false)}
        sx={{
          '& .MuiDrawer-paper': {
            width: { xs: '100%', sm: 400 },
            p: 3,
          },
        }}
      >
        <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Search Filters
          </Typography>
          <IconButton onClick={() => setFilterDrawerOpen(false)} size="small">
            <ClearIcon />
          </IconButton>
        </Box>
        <Divider sx={{ mb: 3 }} />

        <Stack spacing={2.25} sx={{ height: 'calc(100% - 72px)' }}>
          <TextField
            fullWidth
            size="small"
            label="Name"
            value={customFilters.name}
            onChange={(e) => handleCustomFilterChange('name', e.target.value)}
            placeholder="Search by name"
          />

          <TextField
            fullWidth
            size="small"
            label="Email"
            value={customFilters.email}
            onChange={(e) => handleCustomFilterChange('email', e.target.value)}
            placeholder="Search by email"
          />

          <TextField
            fullWidth
            size="small"
            label="Mobile"
            value={customFilters.mobile}
            onChange={(e) => handleCustomFilterChange('mobile', e.target.value)}
            placeholder="Search by mobile"
          />

          <TextField
            fullWidth
            size="small"
            label="Pincode"
            value={customFilters.pincode}
            onChange={(e) => handleCustomFilterChange('pincode', e.target.value)}
            placeholder="Search by pincode"
          />

          <FormControl fullWidth size="small">
            <InputLabel>Qualification</InputLabel>
            <Select
              value={customFilters.qualification}
              label="Qualification"
              onChange={(e) => handleCustomFilterChange('qualification', e.target.value)}
            >
              <SelectMenuItem value="">
                <em>All</em>
              </SelectMenuItem>
              {qualificationArray.map((qual) => (
                <SelectMenuItem key={qual} value={qual}>
                  {qual}
                </SelectMenuItem>
              ))}
            </Select>
          </FormControl>

          {/* <TextField
            fullWidth
            size="small"
            label="Source"
            value={customFilters.source}
            onChange={(e) => handleCustomFilterChange('source', e.target.value)}
            placeholder="Search by source"
          /> */}

          <Grid container spacing={1.5}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                size="small"
                type="date"
                label="Registered From"
                InputLabelProps={{ shrink: true }}
                inputProps={{ max: new Date().toISOString().slice(0, 10) }}
                value={customFilters.registrationFrom}
                onChange={(e) => handleCustomFilterChange('registrationFrom', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                size="small"
                type="date"
                label="Registered To"
                InputLabelProps={{ shrink: true }}
                inputProps={{ max: new Date().toISOString().slice(0, 10) }}
                value={customFilters.registrationTo}
                onChange={(e) => handleCustomFilterChange('registrationTo', e.target.value)}
              />
            </Grid>
          </Grid>

          {/* <FormControl fullWidth size="small">
            <InputLabel>Onboarding</InputLabel>
            <Select value={customFilters.onboardingStatus} label="Onboarding" onChange={(e) => handleCustomFilterChange('onboardingStatus', e.target.value)}>
              <SelectMenuItem value=""><em>All</em></SelectMenuItem>
              <SelectMenuItem value="complete">Complete</SelectMenuItem>
              <SelectMenuItem value="incomplete">Incomplete</SelectMenuItem>
            </Select>
          </FormControl> */}

          <FormControl fullWidth size="small">
            <InputLabel>Onboarding Step</InputLabel>
            <Select value={customFilters.regFormStatus} label="Raw Reg Form Status" onChange={(e) => handleCustomFilterChange('regFormStatus', e.target.value)}>
              {regFormStatusOptions.map((item) => (
                <SelectMenuItem key={item.value || 'all'} value={item.value}>{item.label}</SelectMenuItem>
              ))}
            </Select>
          </FormControl>
          {roleFilterError && (
            <Typography variant="caption" color="error">{roleFilterError}</Typography>
          )}

          <Autocomplete
            fullWidth
            size="small"
            options={roleFilterOptions.families}
            loading={roleFilterLoading.families}
            value={roleFilterOptions.families.find((family) => family.family_id === customFilters.familyId) || null}
            getOptionLabel={(option) => getRoleLabel(option, "family")}
            isOptionEqualToValue={(option, value) => option.family_id === value.family_id}
            onChange={(event, value) => {
              handleCustomFilterChange('familyId', value?.family_id || '');
              handleCustomFilterChange('groupId', '');
              handleCustomFilterChange('roleId', '');
            }}
            disabled={roleFilterLoading.families}
            renderInput={(params) => <TextField {...params} label="Family" placeholder="Search family" />}
          />
          {roleFilterLoading.families && <CircularProgress size={18} sx={{ mt: 1 }} />}

          <Autocomplete
            fullWidth
            size="small"
            options={roleFilterOptions.groups}
            loading={roleFilterLoading.groups}
            value={roleFilterOptions.groups.find((group) => group.role_group_id === customFilters.groupId) || null}
            getOptionLabel={(option) => getRoleLabel(option, "group")}
            isOptionEqualToValue={(option, value) => option.role_group_id === value.role_group_id}
            onChange={(event, value) => {
              handleCustomFilterChange('groupId', value?.role_group_id || '');
              handleCustomFilterChange('roleId', '');
            }}
            disabled={!customFilters.familyId || roleFilterLoading.groups}
            renderInput={(params) => <TextField {...params} label="Group" placeholder="Search group" />}
          />
          {roleFilterLoading.groups && <CircularProgress size={18} sx={{ mt: 1 }} />}

          <Autocomplete
            fullWidth
            size="small"
            options={roleFilterOptions.roles}
            loading={roleFilterLoading.roles}
            value={roleFilterOptions.roles.find((role) => role.role?.role_id === customFilters.roleId) || null}
            getOptionLabel={(option) => getRoleLabel(option, "role")}
            isOptionEqualToValue={(option, value) => option._id === value._id}
            onChange={(event, value) => handleCustomFilterChange('roleId', value?.role?.role_id || '')}
            disabled={!customFilters.groupId || roleFilterLoading.roles}
            renderInput={(params) => <TextField {...params} label="Role" placeholder="Search role" />}
          />
          {roleFilterLoading.roles && <CircularProgress size={18} sx={{ mt: 1 }} />}
          <TextField fullWidth size="small" label="State" value={customFilters.state} onChange={(e) => handleCustomFilterChange('state', e.target.value)} />
          <TextField fullWidth size="small" label="District" value={customFilters.district} onChange={(e) => handleCustomFilterChange('district', e.target.value)} />
          {/* <TextField fullWidth size="small" label="City" value={customFilters.city} onChange={(e) => handleCustomFilterChange('city', e.target.value)} /> */}
          <FormControl fullWidth size="small">
            <InputLabel>Has Applied</InputLabel>
            <Select value={customFilters.hasApplied} label="Has Applied" onChange={(e) => handleCustomFilterChange('hasApplied', e.target.value)}>
              <SelectMenuItem value=""><em>All</em></SelectMenuItem>
              <SelectMenuItem value="true">Yes</SelectMenuItem>
              <SelectMenuItem value="false">No</SelectMenuItem>
            </Select>
          </FormControl>


          <Divider />

          <Stack direction="row" spacing={2} sx={{ mt: 'auto', pt: 2, position: 'sticky', bottom: 0, bgcolor: 'background.paper' }}>
            <Button
              fullWidth
              variant="outlined"
              startIcon={<ClearIcon />}
              onClick={() => {
                clearCustomFilters();
                setFilterDrawerOpen(false);
              }}
              sx={{ borderRadius: 2 }}
            >
              Clear All
            </Button>
            <Button
              fullWidth
              variant="contained"
              startIcon={<SearchIcon />}
              onClick={() => {
                applyCustomFilters();
                setFilterDrawerOpen(false);
              }}
              sx={{
                borderRadius: 2,
                bgcolor: "#f26d3d",
                "&:hover": { bgcolor: "#e35e2f" },
              }}
            >
              Apply
            </Button>
          </Stack>
        </Stack>
      </Drawer>

      <Box className="candidates-section-data">
        {showLoader ? (
          <ReusableLoader />
        ) : (
          <DataTable table={table} />
        )}
      </Box>

      <SureYouWantToDeletModal
        modalTitle=""
        dialogBody="Are you sure you want to delete this user"
        buttonText="Yes"
        openDeleteModal={openDeleteModal}
        setOpenDeleteModal={setOpenDeleteModal}
        onYesClick={() => {
          deleteCandidate();
        }}
      />
      <Backdrop open={exportLoading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1, bgcolor: 'rgba(255,255,255,0.72)' }}>
        <Box sx={{ width: 220, height: 120, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 3, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <ReusableLoader />
        </Box>
      </Backdrop>
    </Box>
  ) : (
    <Unauthorized />
  );
};
export default Candidates;
